StorageUploadModalController.$inject= ['StorageService', 'FileUploader', '$localStorage'];
export default function StorageUploadModalController(StorageService, FileUploader, $localStorage) {
    var ctrl = this;

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.database = changes.resolve.currentValue.params.database;
            if (1) {
                ctrl.uploader.formData.push({
                    name: 'Data Object',
                    database: ctrl.database
                });
            }
        }
    }


    ctrl.uploader = new FileUploader({
        url: '/api/v1/object',
        alias: 'files',
        headers: {
            //"Authorization": 'Bearer' + ' ' + $localStorage.currentUser.token,
            //"x-access-token": $localStorage.currentUser.token
        },
        formData: [
            //{'database': ctrl.database},
            //{'name': 'databasename_' + ctrl.database}
        ]
    });
    /*
     * Вероятно тo, что порядок размещения обработчиков имеет
     * значение. Нам нужен такой порядок -
     *
     *  1. Event field
     *  2. Event file
     *
     *  See Also: https://github.com/mscdex/busboy/issues/43#issuecomment-51053476
     */


    
    if (1) {
        ctrl.uploader.formData.push({
            name: 'Data Object',
            database: ctrl.database
        });
    }


    ctrl.uploader.filters.push({
        name: 'sizeFilter',
        fn: function(fileItem, options) {
            return fileItem.size <= 130*1024*1024;
        }
    });

    ctrl.uploader.onErrorItem = function(fileItem, response, status, header) {
        console.log('Upload file error');
        console.log(status);
    };

    ctrl.uploader.onCompleteItem = function(fileItem, response, status, header) {
        console.log('Upload file complete');
        console.log(status);
    };

    ctrl.uploader.onSuccessItem = function(fileItem, response, status, headers) {
        console.log('Upload file success');
        console.log(status);
    };

    ctrl.ok = function() {
        ctrl.modalInstance.close(ctrl.content);
    };

    ctrl.cancel = function() {
        ctrl.modalInstance.dismiss("cancel");
    };
}
